import {
  AccountGroupForm,
  AccountLedgerForm,
  BankAccountForm,
  BankForm,
  BillUnitDefinitionForm,
  EntryCategoryForm,
  FinancialYearForm,
  LineItemTemplateForm,
  OrganizationForm,
  PartyCompositeForm,
  SacCodeForm,
  TaxLedgerSetupForm,
  UserForm,
  ShortRemarkForm
} from "./fixedForms";
import type { EntityFormDefinition } from "./types";

export const entityFormRegistry: Record<string, EntityFormDefinition> = {
  "party-composite": { title: "Party", createTitle: "Add Customer / Vendor", editTitle: "Edit Customer / Vendor", component: PartyCompositeForm },
  "short-remarks": { title: "Short Remark", createTitle: "Create Short Remark", editTitle: "Edit Short Remark", component: ShortRemarkForm, presentation: "compact-modal" },
  bank: { title: "Bank", createTitle: "Create Bank", editTitle: "Edit Bank", component: BankForm, presentation: "compact-modal" },
  "bank-account": { title: "Bank Account", createTitle: "Create Bank Account", editTitle: "Edit Bank Account", component: BankAccountForm },
  "account-ledger": { title: "Ledger", createTitle: "Create Ledger", editTitle: "Edit Ledger", component: AccountLedgerForm, presentation: "compact-modal" },
  "account-group": { title: "Account Group", createTitle: "Create Account Group", editTitle: "Edit Account Group", component: AccountGroupForm, presentation: "compact-modal" },
  "entry-category": { title: "Entry Category", createTitle: "Create Entry Category", editTitle: "Edit Entry Category", component: EntryCategoryForm },
  "sac-code": { title: "SAC Code", createTitle: "Create SAC Code", editTitle: "Edit SAC Code", component: SacCodeForm },
  "financial-year": { title: "Financial Year", createTitle: "Create Financial Year", editTitle: "Edit Financial Year", component: FinancialYearForm },
  organization: { title: "Company", createTitle: "Create Company", editTitle: "Edit Company", component: OrganizationForm },
  user: { title: "User", createTitle: "Create User", editTitle: "Edit User", component: UserForm },
  "tax-ledger-setup": { title: "Tax Ledger Setup", createTitle: "Tax Ledger Setup", editTitle: "Tax Ledger Setup", component: TaxLedgerSetupForm },
  "line-item-template": { title: "Line Item Template", createTitle: "Create Line Item Template", editTitle: "Edit Line Item Template", component: LineItemTemplateForm },
  "bill-unit": { title: "Bill Unit", createTitle: "Create Bill Unit", editTitle: "Edit Bill Unit", component: BillUnitDefinitionForm }
};
